import useExchangeRates from '@/shared/data/useExchangeRates';
import convertCurrency from '@/utils/convertCurrency';

const useTotalByCurrency = () => {
  const { data: exchangeRates } = useExchangeRates();

  const totalByCurrency = (values: { amount: number; fromCurrency: string; toCurrency: string }[]) =>
    values.reduce((total, value) => {
      return (
        total +
        convertCurrency({
          amount: value.amount,
          exchangeRates,
          from: value.fromCurrency,
          to: value.toCurrency,
        })
      );
    }, 0);

  return { totalByCurrency };
};

export default useTotalByCurrency;
